import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const EmptyContainer = styled.div`
  position: absolute;
  text-align: center;
  top: ${pxToRem(85)};
  width: 100%;
`;

export const EmptyRowNeededForFirefox = styled.div`
  display: table-row;
  height: ${pxToRem(80)};
`;

export const BodyContainer = styled.div`
  overflow: auto;
  height: 100%;
  width: 100%;
  .coreTableBody {
    display: table;
    width: 100%;
    min-width: 100%;
    position: relative;
  }
`;

export const MainCSSContainer = styled.div<{ $isIterableStyle: boolean; $isToolbarShown: boolean }>`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  position: relative;
  height: 100%;
  width: 100%;
  flex: 0 1 auto;
  border-top-left-radius: ${({ $isToolbarShown }) => ($isToolbarShown ? pxToRem(4) : pxToRem(3))};
  border-top-right-radius: ${({ $isToolbarShown }) => ($isToolbarShown ? pxToRem(4) : pxToRem(3))};
  &.canScrollLeft,
  &.canScrollRight {
    .coreTableBody {
      .coreTableHeader,
      .coreTableRow {
        width: 100%;
      }
    }
  }
  &.canScrollDown {
    .coreTableBody {
      .coreTableHeader {
        .coreTableHeaderCell {
          [data-role='actions'] {
            border-bottom: 0;
          }
        }
      }
    }
  }
  [data-role='toolbar'] + & {
    border-bottom: 0 !important;
  }
  .coreTableHeader,
  .coreTableRow {
    [data-docked='true'] {
      position: sticky;
      left: 0;
      border-right: ${pxToRem(1)} solid #d6d6d6;
      overflow: unset;
      &.coreTableHeaderCell {
        z-index: 3;
      }
      &:after {
        content: '';
        display: block;
        left: unset;
        right: -${pxToRem(15)};
        height: calc(100% + 1px);
        .canScrollLeft & {
          opacity: 1;
          transform: scaleY(1);
        }
      }
    }
  }
  .coreTableCell {
    padding: ${({ $isIterableStyle }) =>
      $isIterableStyle ? pxToRem(15) : `${pxToRem(4)} ${pxToRem(8)}`};
    ${({ $isIterableStyle }) =>
      $isIterableStyle
        ? `
      &:first-child {
        border-left: ${pxToRem(1)} solid #d6d6d6;
      }
      &:last-child {
        border-right: ${pxToRem(1)} solid #d6d6d6;
      }
      &:hover {
        background: #eaf4fa;
      }
    `
        : ''}
  }
`;
